module.exports = __webpack_public_path__ + "static/media/program2.5d5b24f6.png";